export default __webpack_public_path__ + "static/media/photo3.ab849742.jpeg";